import { BaseDropdown } from './component/BaseDropdown';
import { useDropdownOptions } from '../../hooks/useDropdownOptions';
import { BusinessDropdownProps } from './component/type';

const COLUMN_NAMES: string[] = ['Code', 'Description'];

export const OrderPriorityDropdown = (props: BusinessDropdownProps) => {
  const shouldPreventApiCall = props.disabled || props.readOnly;

  const { options: orderPriorityOptions, loading } = useDropdownOptions({
    apiId: 'internal.v1.base-tables',
    operationId: 'GET /promptValues/{windowId}',
    labelAttribute: 'description',
    valueAttribute: 'salesOrderPriority',
    params: {
      windowId: 'salesOrderPriorities',
    },
    shouldPreventApiCall,
  });

  return <BaseDropdown {...props} loading={loading} options={orderPriorityOptions} columnNames={COLUMN_NAMES} />;
};
